import axios from "axios";
import { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../utils/constants";

export const useFormState = (displayError, caseData) => {
  const { hash } = useParams();
  const [formInput, setFormInput] = useState({
    dados_bem: "",
    dados_ficha: "",
    situacao: null,
    recompensa: "",
    avaliacao: {
      placaCorreta: 5,
      localizacao: 5,
      imagem: 5,
      agilidade: 5,
      conduta: 5,
    },
    comentarioAvaliacao: "",
  });
  const [situacaoOptions, setSituacaoOptions] = useState([]);
  const [isCreating, setIsCreating] = useState(false);

  const fetchSituacoes = useCallback(async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/v1/situacoes`);
      const optionsFormatadas = response.data.map((item) => ({
        value: item.nome,
        label: item.nome,
      }));
      setSituacaoOptions(optionsFormatadas);
    } catch (error) {
      console.error("Erro ao buscar situações da API:", error);
    }
  }, []);

  useEffect(() => {
    fetchSituacoes();
  }, [fetchSituacoes]);

  useEffect(() => {
    // Se temos dados do caso E esses dados têm um valor em 'dados_bem'...
    if (caseData && caseData.dados_bem && caseData.dados_bem.trim() !== "") {
      // ...atualizamos o estado do formulário com esse valor.
      setFormInput((prevState) => ({
        ...prevState,
        dados_bem: caseData.dados_bem,
      }));
    }
  }, [caseData]); // Este efeito roda sempre que 'caseData' for carregado/alterado

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormInput((prev) => ({ ...prev, [name]: value }));
  };

  const handleSituacaoChange = (selectedOption) => {
    setFormInput((prev) => ({ ...prev, situacao: selectedOption }));
  };

  const handleCreateSituacao = async (inputValue) => {
    const nomeSituacao = inputValue?.trim();

    if (!nomeSituacao) {
      displayError("O nome da situação não pode ser vazio.");
      return;
    }

    setIsCreating(true);
    try {
      const response = await axios.post(`${API_BASE_URL}/api/v1/situacoes`, {
        nome: nomeSituacao,
        hash: hash,
      });

      const novaSituacaoSalva = response.data;
      const newOption = {
        value: novaSituacaoSalva.nome,
        label: novaSituacaoSalva.nome,
      };

      setSituacaoOptions((prev) => [...prev, newOption]);
      setFormInput((prev) => ({ ...prev, situacao: newOption }));
    } catch (error) {
      console.error("Erro ao salvar nova situação:", error);
      const message =
        error.response?.data?.message || "Erro ao criar situação.";
      displayError(message);
    } finally {
      setIsCreating(false);
    }
  };

  const handleAvaliacaoChange = (campo, valor) => {
    setFormInput((prev) => ({
      ...prev,
      avaliacao: {
        ...prev.avaliacao,
        [campo]: Number(valor),
      },
    }));
  };

  const isFormValid = () => {
    return formInput.dados_bem && formInput.situacao;
  };

  return {
    formInput,
    situacaoOptions,
    isCreating,
    handleChange,
    handleSituacaoChange,
    handleCreateSituacao,
    handleAvaliacaoChange,
    isFormValid,
  };
};
